<div class="page-section">
  <!-- section-dashboard-payment-activity -->
  <div class="billing-operation-dashboard-head">
    <reb-ngx-heading-label color="#15245A" size="h3" weight="500"> Billing Operations 
      <reb-ngx-heading-label color="#15245A" size="h5" weight="400">( Last 7 Days )</reb-ngx-heading-label>
    </reb-ngx-heading-label>
  </div>
  <reb-ngx-banner *ngIf="isActivityError" mood="error" message="There was an error when trying to retrieve billing operations."></reb-ngx-banner>

  <div *ngIf="!isActivityError && isPaymentActivityReady" class="page-section-body border noborder-important">
    <div class="mat-list mat-list-base custom-mat-list billing-operation-dashboard-wrapper">
      <reb-ngx-card [showHeader]="true" width="size1of1" class="billing-operation-dashboard-card"
          *ngFor="let item of collectionOfPaymentTotals">
      <div card-header-title>
        <reb-ngx-heading-label mood="none" size="h6" weight="500" >
          {{item.keyName|titlecase}}
        </reb-ngx-heading-label>
      </div>
      <div class="card-body-content">
        <reb-ngx-label mood="default" size="22" weight="700" class="billing-operation-card-count"> 
          {{item.count}}
        </reb-ngx-label>
        <reb-ngx-label color="#C9D0DB" size="16" weight="600"> 
          {{companyCurrencyBase?.currency?.symbol}}{{item.amount}}
        </reb-ngx-label>
      </div>
      </reb-ngx-card>
    </div>
  </div>
  <div *ngIf="!isActivityError && isPaymentActivityReady" class="page-section-body border noborder-important" style="margin-top:24px;">
    <app-billing-operation-chart *ngIf="isPaymentActivityReady"
      [collectionOfPaymentActivityDates] = collectionOfPaymentActivityDates
      [paymentActivitySeries]=paymentActivitySeries
      >
    </app-billing-operation-chart>
  </div>
  <skeleton-loader *ngIf="!isPaymentActivityReady" [theme]="{'width': '100%', 'height': '400px'}"></skeleton-loader> 
</div>
